<div>
    <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="50%">
            <div fxLayout="row" fxLayoutAlign="center" class="div-info">
                <div fxFlex="10" class="div-icon">
                    <a (click)="goLocationCar()">
                        <!-- <mat-icon class="mat-18">cancel</mat-icon> -->
                        <mat-icon class="mat-return">highlight_off</mat-icon>
                    </a>
                </div>
                <div fxFlex="10" class="div-icon-date">
                    <mat-icon class="mat-return apply-display">date_range</mat-icon>
                </div>
                <div fxFlex="60">
                    <div  fxLayout="column">
                        <p class="text-period">
                            Du
                            <span>{{dataSearchService.templateSearchCar.dateStart | date:'EEE d MMM'|titlecase }}{{dataSearchService.templateSearchCar.periodStart}}</span>
                            <br>
                            Au
                            <span>{{dataSearchService.templateSearchCar.dateEnd | date:'EEE d MMM'|titlecase }}{{dataSearchService.templateSearchCar.periodEnd}}</span>
                        </p>
                    </div>
                </div>
                <div fxFlex="20">
                    <div class="div-price">
                        <p class="price">
                            <span>{{dataSearchService.priceLocation}} {{appService.getCurrency()}}</span>
                        </p>
                        <p class="text-price">Prix total TTC</p>
                    </div>
                </div>
            </div>
            <app-latest-location-form></app-latest-location-form>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50%">
            <app-map-senegal [mapHome]="false" [mapLatestLocation]="true" [geometry]="geometry" [markers]="markers"></app-map-senegal>
        </div>
    </div>
</div>
